import { getOffers } from "./pl-offers";

import { getPoznanConfig } from "./pl-cities/poznan";
import { getWroclawConfig } from "./pl-cities/wroclaw";
import { getGdanskConfig } from "./pl-cities/gdansk";
import { getKatowiceConfig } from "./pl-cities/katowice";
import { getWarszawaBoxConfig } from "./pl-cities/warszawa-box";
import { getTrojmiastoConfig } from "./pl-cities/trojmiasto";
import { getKatoConfig } from "./pl-cities/kato";
import { getKrakowConfig } from "./pl-cities/krakow";
import { getLodzConfig } from "./pl-cities/lodz";
import { getWarszawaConfig } from "./pl-cities/warszawa";

// siteUrl should be '/key', where key is the key of the location in the locations object
// this is because MainPage bases on the location param to render the correct location

export const getLocationsData = () => {
  return {
    countryOptions: {
      locationBackgroundVideoID: "2T3tux4fqUA",
      locationMobileBackgroundVideoID: "o593p1V80yk",
      offers: getOffers(),
      socials: {
        facebook: "https://www.facebook.com/pixelxlpoland",
        instagram: "https://www.instagram.com/pixelxlpoland/",
        tiktok: "https://www.tiktok.com/@pixelxlpoland",
      },
      telephoneNumber: "+48 22-307-26-72",
      workingHours: {
        mondayToFriday: "8:00 - 21:00",
        saturday: "9:00 - 20:00",
        sunday: "10:00 - 20:00",
      },
    },
    cities: {
      wroclaw: getWroclawConfig(),
      katowice: getKatowiceConfig(),
      "warszawa-box": getWarszawaBoxConfig(),
      gdansk: getGdanskConfig(),
      poznan: getPoznanConfig(),
      krakow: getKrakowConfig(),
      trojmiasto: getTrojmiastoConfig(),
      kato: getKatoConfig(),
      lodz: getLodzConfig(),
      warszawa: getWarszawaConfig(),
    },
  };
};
